

export default {

    async SET_TOTAL_LABOR_ORDER(state, totalLaborOrders) {
        state.totalLaborOrders = totalLaborOrders
    },
    async ADD_NEW_LABOR_ORDER(state, order) {
        state.laborOrders.splice(0, 0, order) 
    },
    async SET_LABOR_ORDER(state, laborOrders) {
        state.laborOrders = laborOrders
    },
    async UPDATE_LABOR_ORDER(state, order) {
        const laborOrderIndex = state.laborOrders.findIndex((p) => p.idOrder == order.idOrder)
        Object.assign(state.laborOrders[laborOrderIndex], order)
    },

    REMOVE_LABOR_ORDER(state, idOrder) {
        const laborOrderIndex = state.laborOrders.findIndex((p) => p.idOrder == idOrder)
        state.laborOrders.splice(laborOrderIndex, 1)
    },
    
    async SET_LABOR_ORDER_FILTERED(state, laborOrders) {
        state.laborOrdersFiltered = laborOrders
    },

    REMOVE_LABOR_ORDER_FILTERED(state, idOrder) {
        const laborOrderIndex = state.laborOrdersFiltered.findIndex((s) => s.idOrder == idOrder)
        state.laborOrdersFiltered.splice(laborOrderIndex, 1)
    },
    

}
 